// src/components/TabNav.tsx (v2.5、 2026-05-26 旧入院実績を非表示、 予算・前年比較を入院実績に昇格)
// タブ切替ナビ。サイドバー (フィルタ) は共通維持、メインだけ切替。
import { useFilters, BETA_TABS, PROFIT_BASIS_DISCHARGE_ENABLED, type TabKey } from "../store";
import { gpText } from "../lib/gpMode";

// 2026-06-16 ユーザ指示: 入院実績/要確認診療科 を非表示 (タブ自体は残すが nav から除外)。
// 2026-06-18 ユーザ指示: 入院実績 を入院KPIの後に復活 (要確認診療科は引き続き非表示)。
// 並び: 入院KPI → 入院実績 → DPC分析 → 行為別 → 手術 → 入院経路 → 明細分析 → 経営PL → 元データ
export const TABS: { key: TabKey; label: string; icon: string; desc: string }[] = [
  { key: "外来収入", label: "外来収入", icon: "💴", desc: "外来の収入を診療科・医師・診療行為別に分け、前年同期間との増減を確認" },
  { key: "給与見込み・GP比較", label: "給与見込み・GP比較", icon: "📊", desc: "4月比率固定案と従来の給与見込みによるGPを比較" },
  { key: "参照データ一覧", label: "参照データ一覧", icon: "📋", desc: "年月ごとのデータソースと原本の確認状況" },
  // [2026-07-21 ユーザ指示] 正式版の並び: 入院実績 → 行為別売上 → 手術売上 → 手術件数 → 入院経路 →
  //   DPC分析 → 粗利分析 → 相関分析 → PL。入院KPI/入院詳細実績(旧入院実績)/明細分析/元データはβへ。
  { key: "入院実績(前年度・予算比較)", label: "入院実績", icon: "📈", desc: "指定月範囲の今年度実績・予算・前年度実績を月平均で比較。年度12ヶ月グラフと月別マトリックスをA4横1枚に集約" },
  { key: "行為別売上",  label: "行為別売上",  icon: "💴", desc: "入院料/手術(輸血除く)/その他 の売上。入院実績と同じ 開始月/終了月 (年度内) で指定した期間の月平均を、主要4指標カード(前年度同期間比・年度の折れ線)+直近13ヶ月の月次推移積み上げ棒+科別×月別マトリクス(年度12ヶ月)で見る。科別も入院実績の入院収入と一致" },
  { key: "入院料分析", label: "入院料分析", icon: "🏥", desc: "入院基本料・特定入院料を6区分へ分解。高度病床の算定一致と回復期・特別入院基本料を分析" },
  { key: "短期滞在3分析", label: "短期滞在3", icon: "⏱️", desc: "算定項目別の制度点数、退院までの日数分布、術前・術後日数と入院単価を分析" },
  { key: "室料差額", label: "個室料", icon: "🛏️", desc: "個室料を税込・確定月で。売上・個室料徴収数(徴収率)・徴収1日あたり室料・未徴収・減額分のKPIカード(前年同期間比・年度推移)、個室の使われ方(月平均比較)、月別の個室料(料金別)、徴収率、料金表の新旧対応" },
  { key: "手術売上", label: "手術売上", icon: "💴", desc: "科別手術売上 (手術会計件数/総金額/手技/材料/薬剤) + 手術(Kコード)別の金額分布。手術=診療識別50相当 (輸血含む・麻酔除く)・診療科=入院主科" },
  { key: "手術",        label: "手術件数",    icon: "🔪", desc: "手術件数の月次推移 / 予算比較 / 診療科別 (手術台帳ベース)" },
  { key: "急性期総合体制加算3", label: "急性期総合体制加算3", icon: "🎯", desc: "手術等の集積性の要件(全身麻酔2,000件＋ア〜キのうち5つ)を年度累計で見張る。基準の経過日数按分との差・前年同期比の着地見込み・月別件数。確定会計＋速報会計(未確定月)・毎月12日更新" },
  { key: "入院経路",        label: "入院経路",        icon: "🚪", desc: "新規入院の経路分析 (予定/緊急 × 紹介 × 経由 × 科別)" },
  { key: "紹介・入院分析", label: "紹介実績", icon: "✉️", desc: "紹介元・診療科・地域の増減、4月始まりの前年度月別比較、紹介入院率との照合" },
  { key: "退院先分岐", label: "退院先分岐", icon: "↗", desc: "急性期終了日を基準に退院先を予定・緊急別で集計" },
  { key: "DPC分析",     label: "DPC分析", icon: "🔬", desc: "DPC 階層別 (6/7/8/10/11/12/13/14 桁) のランキング + 14 桁包括点数 階段チャート (最下部に統合)" },
  // ★2026-08-27: 退院日基準を封鎖中 (PROFIT_BASIS_DISCHARGE_ENABLED=false) は 退院日基準/DPC別が
  //   画面に無いので説明も在院日基準のものだけにする (理由と復活手順は store.ts の同定数)。
  { key: "粗利分析(医師別なし)", label: "粗利分析", icon: "💹", desc: PROFIT_BASIS_DISCHARGE_ENABLED
      ? "科別/DPC別の粗利・1日粗利単価・群分類(1日粗利単価で4分類)。退院日基準で退院数/入院日数中央値・DPC階層ドリル"
      : "科別の粗利・1日粗利単価・群分類(1日粗利単価で4分類)" },
  { key: "相関分析",    label: "相関分析",    icon: "🔗", desc: "先頭指標を基準にした入院実績指標の月次相関 散布図行列。基準との相関順に並ぶ・各月=1サンプル" },
  { key: "職員数・人件費", label: "職員数・人件費", icon: "👥", desc: "人事原表の月別・部署別人数と会計元帳の人件費。前年同月・予算比較" },
  { key: "経営PL",      label: "PL",      icon: "💰", desc: "経営PLの予算実績・前年差異・利益推移 (月別/年度累計/直近12ヶ月) + 差異ランキング" },
  { key: "AI分析", label: "AI分析", icon: "✦", desc: "全体を俯瞰し、今月の重点論点を深掘り。根拠と次の行動へ" },
  // ── 以下はベータ (BETA_TABS) ──
  // [2026-08-03] 入院実績(医師別): 正式版「入院実績」と同じ構成 + 科別マトリックスの下に医師別マトリックス。
  //   科別の行クリックでその科に絞り込み → 医師別も同じ科の医師だけになる。
  { key: "入院実績(医師別)", label: "入院実績(医師別)", icon: "🧑‍⚕️", desc: "入院実績に医師別マトリックスを追加した版。科別マトリックスの行クリックで科を絞り込み → 医師別も連動。印刷は 科フォーカス時=科1行+医師別でA4横1枚 / 未フォーカス時=医師別は次ページ(上位20/25/30行)" },
  // [2026-08-22 ユーザ指示] 入院KPI は廃止 (使わないので没)。入院実績タブが上位互換。
  { key: "入院実績",        label: "入院詳細実績",    icon: "📊", desc: "KPI カード + 月次推移 + 月別マトリックス + 注目指標の科別実績 (予算・前年比つき)" },
  { key: "明細分析",    label: "明細分析",    icon: "🔎", desc: "診療行為/加算の増減 movers。直近12ヶ月vs前年で 増加/減少TOP。加算・手術の伸び落ちを発見" },
  { key: "元データ",    label: "元データ",    icon: "⬇", desc: "集計データの Excel(xlsx) 出力" },
  { key: "粗利分析",    label: "粗利分析(医師別あり)",    icon: "💹", desc: PROFIT_BASIS_DISCHARGE_ENABLED
      ? "粗利分析に医師別を足した版。科/医師クリックで絞り込み・DPC桁drill"
      : "粗利分析に医師別を足した版 (医師別/DPC別は現在停止中)" },
  // [2026-08-26 ユーザ指示] 粗利=延数×1日単価の分解ビュー。単価だけの群分類が延数で稼ぐ科を
  //   過小評価することを、等GP曲線つき散布図と群分類色のGPランキングで可視化する。
  { key: "粗利効率分析", label: "粗利効率分析", icon: "🛏️", desc: "粗利=延数×1日粗利単価の分解。等GP曲線つき散布図に現行の群分類(横帯)を重ね、延数で稼ぐ科の過小評価を可視化。効率化は①空床を埋める(延数)→②単価を高める" },
  { key: "手術会計明細", label: "手術会計明細", icon: "🔪", desc: "手術を会計明細区分(手術料/特定材料/麻酔/薬剤/輸血)×台帳分/台帳外×診療科×個別tencdに分解。診療統計明細リバエン×手術台帳突合・金額完全保存。202404実測" },
  { key: "請求会計速報", label: "速報進捗(入院ペース)", icon: "🏃", desc: "速報進捗ビュー。○日(最新月の最新date)時点で 実績/予算(日数按分)/予算差/前年実績/前年差 を病院全体+各科(入院)+外来(病院全体)で。現時点で予算達成ペースか・前年を上回るペースかを見る。会計リバエン速報化B案・GUI月次CSV非依存" },
  { key: "速報売上", label: "速報売上(会計別)", icon: "⚡", desc: "速報の売上を会計(RP)単位まで細かく。日次パルス(手技/薬剤/材料/DPC包括)・KCODE別売上(束カード=PCI/ABL等・倍率寄与)・前月比寄与・RPドリル。出来高=rphd満額・補正なし生値・直近2日は入力途上" },
  { key: "看護必要度速報", label: "看護必要度速報", icon: "🩺", desc: "D-2までの月初来速報。急性期病院A・急性期総合体制加算3・ICU1・HCU1・救命救急1/2の全要件、病棟差、項目別、データ品質を毎日確認" },
  { key: "データ辞書", label: "データ辞書", icon: "🗂️", desc: "配信DB(dashboard/dpc_hier/meisai_act)のテーブルを1つずつ確認。テーブル説明・列定義(型/NULL率/distinct)・リレーション・実データプレビュー(個人情報列はマスク)。PII監査バッジ付き" },
  { key: "収入速報", label: "収入速報", icon: "💴", desc: "日次更新の収入・手術・PCI・ABL・DSAと予算達成率" },
  {key:"外来予約",label:"外来予約",icon:"📅",desc:"科別空き状況・棒グラフ・医師別・予約から受診までの日数"},
];

/** 画面のタブ表示名を、ブラウザタイトルなどでも共通利用する。 */
export function tabLabel(key: TabKey): string {
  // [開発版(新GP)] /theta では「粗利分析」→「GP分析」と表示する
  return gpText(TABS.find((tab) => tab.key === key)?.label ?? key);
}

// 正式版 (App) は BETA_TABS を除外。ベータ版 (BetaApp) は only={BETA_TABS} で限定。
const OFFICIAL_TABS = TABS.filter((t) => !BETA_TABS.includes(t.key));

export function TabNav({ only }: { only?: TabKey[] }) {
  const f = useFilters();
  const shown = only ? TABS.filter((t) => only.includes(t.key)) : OFFICIAL_TABS;
  return (
    <nav className="border-b border-slate-200 bg-white sticky top-0 z-10">
      {/* iPad / モバイル: タブ全数が横に入らないときは横スクロール (whitespace-nowrap + overflow-x-auto) */}
      <div className="max-w-[1880px] mx-auto px-3 sm:px-4 flex gap-1 overflow-x-auto whitespace-nowrap">
        {shown.map((t) => {
          const active = f.tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => f.setTab(t.key)}
              className={[
                "px-3 sm:px-4 py-2 text-sm border-b-2 transition-colors shrink-0",
                active
                  ? "border-brand text-brand font-semibold bg-emerald-50/60"
                  : "border-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-50",
              ].join(" ")}
              title={gpText(t.desc)}
            >
              <span className="mr-1">{t.icon}</span>
              {gpText(t.label)}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
